import { useEffect, useState } from 'react';

import { flushEventLog, onEventLogAppend } from '@shared/events';

import { projectReaderStats } from './projection';

/**
 * Loads figures and keeps them current: again after every write to the
 * event log, once the projection has caught up with it. `undefined` while
 * the first load is in flight.
 */
export function useReaderStats<T>(
	load: () => Promise<T>,
	deps: ReadonlyArray<unknown>,
): T | undefined {
	const [value, setValue] = useState<T>();

	useEffect(() => {
		let active = true;
		const refresh = () =>
			void projectReaderStats()
				.then(load)
				.then(
					(next) => {
						if (active) {
							setValue(next);
						}
					},
					() => {},
				);
		// What was just recorded is written first, so opening a stats page
		// shows it.
		void flushEventLog().then(refresh, refresh);
		const off = onEventLogAppend(refresh);
		return () => {
			active = false;
			off();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);

	return value;
}
